<template>
  <div class="content-wrap">
    <div class="content-main">
      <div class="content-header" v-if="!hideTitle">
        <b>{{ headerTitle }}</b>
      </div>
      <div v-if="listData.length">
        <div class="content-list-box">
          <div
            class="content-list-item"
            v-for="(item, index) in listData"
            :key="'list' + index"
          >
            <div class="content-list-item-header">
              <div class="content-list-item-left">
                <div class="content-list-item-num">
                  {{ item.docYear }}&nbsp;&nbsp;{{ item.docNo }}
                </div>
                <h4>{{ item.title }}</h4>
              </div>
              <!-- <div class="content-list-item-right">
              <div class="card-more">立即报名</div>
            </div> -->
            </div>
            <div class="content-list-item-extra">
              <div class="content-list-item-info">
                <div class="content-list-item-icon icon-position"></div>
                <div class="content-list-item-value">{{ item.actAddress }}</div>
              </div>
              <div class="content-list-item-info">
                <div class="content-list-item-icon icon-time"></div>
                <div class="content-list-item-value">
                  {{ item._actStartDate }}
                </div>
              </div>
            </div>
            <div class="content-list-item-body">
              <div
                class="content-list-item-body-item"
                :class="idx === 0 ? 'active' : ''"
                v-for="(progress, idx) in item.progressList"
                :key="index + '_' + idx"
              >
                <div class="body-item-info">{{ progress.nodeText }}</div>
                <div class="body-item-time">{{ progress._date }}</div>
              </div>
            </div>
          </div>
        </div>
        <Pagination
          :currentPage="currentPage"
          :total="total"
          @change="pageChange"
        />
      </div>
      <Empty v-else />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import router from "@/router";
import Pagination from "@/components/Pagination";
import { getUserActList } from "./service/api";

const moduleConfig = {
  1: {
    name: "我的培训",
    actType: "activity",
    api: getUserActList,
  },
  2: {
    name: "我的会议",
    actType: "meeting",
    api: getUserActList,
  },
  3: {
    name: "我的沙龙",
    actType: "salon",
    api: getUserActList,
  },
};
const nodeMap = {
  signUp: "报名",
  publicity: "公示",
  feedback: "反馈",
};
export default {
  data() {
    return {
      headerTitle: "",
      listData: [],
      currentPage: 1,
      pageSize: 10,
      total: 1,
    };
  },
  props: {
    hideTitle: {
      default: false
    }
  },
  components: {
    Pagination,
  },
  watch: {
    $route() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const queryT = router.currentRoute.query.t || 1;
      this.currentModule = moduleConfig[queryT];
      this.headerTitle = this.currentModule.name;
      this.currentPage = 1;
      this.getList();
    },
    getList() {
      const params = {
        current: this.currentPage,
        pageSize: this.pageSize,
      };
      this.currentModule.actType &&
        (params.actType = this.currentModule.actType);
      this.currentModule.api(params).then((res) => {
        this.total = res.totalResult;
        this.listData = (res.list || []).map((item) => {
          item._actStartDate = moment(item.actStartDate * 1000).format(
            "YYYY-MM-DD"
          );
          item.progressList = (item.progressList || []).map((proItem) => {
            proItem.nodeText = nodeMap[proItem.node];
            proItem._date = moment(proItem.time * 1000).format("YYYY-MM-DD");
            return proItem;
          });
          return item;
        });
      });
    },
    pageChange(page) {
      this.currentPage = page;
      this.getList();
    },
    linkTo(uri) {
      router.push(uri);
    },
    // toNoticeDetail(item) {
    // 	this.linkTo(`/notice/detail?aId=${item.id}`);
    // }
  },
};
</script>

<style lang="less" scoped>
.content-main {
  background: #ffffff;
  min-height: 500px;
  padding-bottom: 30px;

  .content-header {
    padding: 20px;
    border-bottom: 1px solid #eeeeee;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #787878;
    line-height: 20px;

    b {
      font-size: 20px;
      font-weight: 500;
      color: #131415;
      margin-right: 10px;
    }
  }

  .content-menu-box {
    padding: 24px 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    .content-menu-list {
      width: 350px;
      padding: 0 21px;
      margin-bottom: 16px;
      display: flex;
      justify-content: space-between;

      .content-menu-item {
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #787878;
        cursor: pointer;

        &.active {
          color: #06ae63;

          .content-menu-item-icon {
            background-image: url(../../assets/images/member-menu-hd-active.png);
          }
        }

        .content-menu-item-icon {
          width: 40px;
          height: 40px;
          margin: 0 auto;
          margin-bottom: 5px;
          background: url(../../assets/images/member-menu-hd.png) no-repeat
            center 0;
          background-size: 100% 100%;
        }

        &:nth-child(2) {
          .content-menu-item-icon {
            background-image: url(../../assets/images/member-menu-pypj.png);
          }
        }

        &:nth-child(3) {
          .content-menu-item-icon {
            background-image: url(../../assets/images/member-menu-tg.png);
          }
        }
      }
    }
    .content-menu-nav {
      width: 350px;
      border-bottom: 1px solid #f1f3f3;
      display: flex;
      justify-content: space-between;

      .content-menu-nav-item {
        padding-bottom: 8px;
        position: relative;
        width: 80px;
        text-align: center;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        cursor: pointer;

        &.active {
          color: #06ae63;
          &::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 6px;
            background: url(../../assets/images/member-menu-nav-active.png)
              no-repeat center 0;
            background-size: 100% 100%;
          }
        }
      }
    }
  }

  .content-list-box {
    margin-bottom: 30px;
    .content-list-item {
      padding: 30px 40px;
      border-bottom: 1px solid #e9e9e9;

      &:last-child {
        border-bottom: none;
      }

      &-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 11px;
      }
      &-num {
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #131415;
        height: 24px;
        line-height: 24px;
        padding: 0 3px 0 7px;
        background: #f1f3f3;
        border: 1px solid #dde4e4;
        margin-right: 4px;
      }

      &-left {
        display: flex;
        align-items: center;

        > h4 {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #131415;
        }
      }
      &-info {
        display: flex;
        margin-right: 40px;
      }
      &-icon {
        width: 14px;
        height: 14px;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 100% 100%;
        margin-right: 8px;

        &.icon-position {
          background-image: url(../../assets/images/icon-position.png);
        }

        &.icon-time {
          background-image: url(../../assets/images/icon-time-light.png);
        }
      }
      &-value {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #787878;
      }
      .card-more {
        width: 84px;
        height: 30px;
        background: #06ae63;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        text-align: center;
        line-height: 30px;
      }
      &-extra {
        display: flex;
        align-items: center;
        margin-bottom: 33px;
      }
      &-body {
        display: flex;
        justify-content: space-between;
        padding: 0 20px;

        &-item {
          position: relative;
          flex: 1;
          height: 62px;

          &:last-child {
            flex: 0;

            &::after {
              display: none;
            }

            .body-item-info {
              width: max-content;
            }
          }

          &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            width: 16px;
            height: 16px;
            background: #ffffff;
            border: 4px solid #dde4e4;
            box-sizing: border-box;
            border-radius: 50%;
          }

          &.active {
            &::before {
              border-color: #06ae63;
            }
            &::after {
              background: #06ae63;
            }

            .body-item-info {
              color: #06ae63;
            }
          }

          &::after {
            content: "";
            position: absolute;
            left: 16px;
            top: 6px;
            width: ~"calc(100% - 16px)";
            height: 4px;
            background: #dde4e4;
          }
        }

        .body-item-info {
          position: absolute;
          left: 0;
          top: 28px;
          transform: translateX(-50%);
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #787878;

          &.error {
            color: #ff3b2f !important;
          }
        }

        .body-item-time {
          position: absolute;
          left: 0;
          top: 48px;
          transform: translateX(-50%);
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #787878;
        }
      }
    }
  }
}
</style>